import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_SCHEDULED_REPORTS,
  CREATE_SCHEDULED_REPORTS,
  UPDATE_SCHEDULED_REPORTS,
  DELETE_SCHEDULED_REPORTS,
  GET_SCHEDULED_REPORT_LOGS_BY_ID,
  REDIRECT_TO_DOWNLOAD_URL
} from "./actionTypes"

import {
  getScheduledReportsSuccess,
  getScheduledReportsError,
  createScheduledReportsSuccess,
  createScheduledReportsError,
  updateScheduledReportsSuccess,
  updateScheduledReportsError,
  deleteScheduledReportsSuccess,
  deleteScheduledReportsError,
  getScheduledReportLogsByIdSuccess,
  getScheduledReportLogsByIdError,
  redirectToDownloadUrlSuccess,
  redirectToDownloadUrlError
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetScheduledReports(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_reports`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json',
      }
    )
    yield put(getScheduledReportsSuccess(response))
  } catch (error) {
    yield put(getScheduledReportsError(error))
  }
}

function* onCreateScheduledReports(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_reports`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createScheduledReportsSuccess(response))
  } catch (error) {
    yield put(createScheduledReportsError(error))
  }
}

function* onUpdateScheduledReports(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_reports/${action.payload.ids.join(',')}`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateScheduledReportsSuccess(response))
  } catch (error) {
    yield put(updateScheduledReportsError(error))
  }
}

function* onDeleteScheduledReports(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_reports/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id
        }
      }
    )
    yield put(deleteScheduledReportsSuccess(response))
  } catch (error) {
    yield put(deleteScheduledReportsError(error))
  }
}

function* onGetScheduledReportLogsById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_report_logs`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json',
      }
    )
    yield put(getScheduledReportLogsByIdSuccess(response, action.scheduled_report_id))
  } catch (error) {
    yield put(getScheduledReportLogsByIdError(error))
  }
}

function* onGetScheduledReportDownloadUrl(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call( 
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/scheduled_report_uploads/presigned_url`,
      action.payload,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json',
      }
    )
    yield put(redirectToDownloadUrlSuccess(response?.data))
  } catch (error) {
    yield put(redirectToDownloadUrlError(error))
  }
}

function* ScheduledReports() {
  yield takeEvery(GET_SCHEDULED_REPORTS, onGetScheduledReports)
  yield takeEvery(CREATE_SCHEDULED_REPORTS, onCreateScheduledReports)
  yield takeEvery(UPDATE_SCHEDULED_REPORTS, onUpdateScheduledReports)
  yield takeEvery(DELETE_SCHEDULED_REPORTS, onDeleteScheduledReports)
  yield takeEvery(GET_SCHEDULED_REPORT_LOGS_BY_ID, onGetScheduledReportLogsById)
  yield takeEvery(REDIRECT_TO_DOWNLOAD_URL, onGetScheduledReportDownloadUrl)
}

export default ScheduledReports;
